<div class="input-group">
                <span class="input-group-prepend"><button class="btn btn-light btn-icon" type="button"><i
                  class="icon-calendar22"></i></button>
                  </span>
  <input type="text" class="form-control {{className}}">
</div>
